import { Activity, Radio } from "lucide-react";
import { useTranslation } from "react-i18next";
import { QuerySection, SectionCard, SectionEmpty } from "@/components/section";
import { ActivityList } from "./ActivityList";
import { useRecentActivity } from "./useRecentActivity";

/** Recent activity across my spaces, and "Happening now" (no presence data yet: empty hint). */
export function SpacesActivity() {
  const { t } = useTranslation("spaces");
  const activity = useRecentActivity(5);
  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
      <SectionCard title={t("activity.title")} className="lg:col-span-2">
        <QuerySection
          query={activity}
          isEmpty={(list) => list.length === 0}
          empty={{ icon: <Activity size={18} />, hint: t("activity.empty") }}
        >
          {(items) => <ActivityList items={items} showSpace />}
        </QuerySection>
      </SectionCard>
      <SectionCard title={t("now.title")}>
        <SectionEmpty icon={<Radio size={18} />} hint={t("now.empty")} />
      </SectionCard>
    </div>
  );
}
